import { Link } from "react-router-dom";
import { Reveal, SectionHeading } from "@/components/Reveal";

const STEPS = [
  { num: "01", title: "Connect With Us", desc: "Complete our carrier inquiry form and tell us about your trucking operation." },
  { num: "02", title: "Carrier Consultation", desc: "We discuss your equipment, operating authority, preferred lanes, and dispatching needs." },
  { num: "03", title: "Complete Onboarding", desc: "Submit the necessary carrier documentation and review the dispatch service agreement." },
  { num: "04", title: "Let's Get Moving", desc: "Once onboarding is complete, our dispatch team begins assisting with freight opportunities and daily coordination." },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="py-20 lg:py-32 px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
    <SectionHeading overline="How It Works" title="Getting Started Is Simple." center testId="how-it-works-heading" tag="Let's Get Moving!" />

    <div className="relative grid md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
      <div className="hidden lg:block absolute top-7 left-[12%] right-[12%] h-px bg-gradient-to-r from-gold/10 via-gold/60 to-gold/10" />
      {STEPS.map((s, i) => (
        <Reveal key={s.num} delay={0.1 * i} className="relative text-center">
          <div data-testid={`step-${s.num}`} className="flex flex-col items-center">
            <div className="relative z-10 w-14 h-14 rounded-none bg-ink border border-gold flex items-center justify-center shadow-[0_0_25px_rgba(212,175,55,0.2)]">
              <span className="font-accent text-gold font-bold text-lg">{s.num}</span>
            </div>
            <h3 className="font-display text-xl uppercase tracking-wide text-white mt-6 mb-3">{s.title}</h3>
            <p className="text-sm text-zinc-400 leading-relaxed max-w-xs">{s.desc}</p>
          </div>
        </Reveal>
      ))}
    </div>

    <Reveal delay={0.35} className="text-center mt-16">
      <Link to="/become-a-carrier" data-testid="become-carrier-btn" className="btn-gold">
        Become a Carrier
      </Link>
    </Reveal>
  </section>
);
